import React from 'react';

export type InfoItemsContextValues = {
    bullets: boolean;
};

export const InfoItemsContext = React.createContext<InfoItemsContextValues>({ bullets: false });
